import {
  LOAD_PRODUCTS_INVENTORY,
  SET_PRODUCTS_INVENTORY_LIST,
  LOAD_STORE_INVENTORY,
  SET_STORE_INVENTORY,
  ADD_PRODUCT_TO_REPLENISH,
  RESET_PRODUCTS_TO_REPLENISH,
  REPLENISH_PRODUCTS,
  TOGGLING_PRODUCT_VISIBILITY,
  SET_UPDATED_PRODUCT_INVENTORY,
  RESET_INVENTORY_STATE,
  INVENTORY_PAGINATION_COUNT,
  STORE_INVENTORY_PAGINATION,
  REQUEST_ESTIMATE_COUNTER,
  UPDATING_PRODUCT,
  UPDATE_PRODUCT_REPLENISH_QUANTITY,
  UPDATE_PRODUCT_REPLENISH_ERROR,
  SET_STOCK_THRESHOLD_VALUE
} from '@/state/mutationTypes'

import getInventoryStoreDefaultState from './inventoryStoreDefaultState'

export default {
  [REQUEST_ESTIMATE_COUNTER](state, payload) {
    state.requestEstimateCount = payload
  },
  [LOAD_PRODUCTS_INVENTORY](state, payload) {
    state.loadingProductInventory = payload
  },
  [SET_PRODUCTS_INVENTORY_LIST](state, payload) {
    state.productInventoryList = payload
  },
  [LOAD_STORE_INVENTORY](state, payload) {
    state.loadingStoreInventory = payload
  },
  [SET_STORE_INVENTORY](state, payload) {
    state.storeInventoryList = payload
  },
  [SET_STOCK_THRESHOLD_VALUE](state, payload) {
    state.stockThresholdValue = payload
  },
  [ADD_PRODUCT_TO_REPLENISH](state, payload) {
    let productInventoryList = [...state.productInventoryList]
    const productIndex = productInventoryList.findIndex(
      product => product.id == payload.id
    )
    if (
      payload.row &&
      payload.row.sortedProductVaraints &&
      payload.row.sortedProductVaraints.length > 1
    ) {
      const variantIndex = payload.row.sortedProductVaraints.findIndex(
        productVariant => productVariant.id === payload.variant.id
      )

      productInventoryList[productIndex].sortedProductVaraints[
        variantIndex
      ].replenish = payload.replenish

      if (
        productInventoryList[productIndex].sortedProductVaraints.find(
          variant => variant.replenish
        )
      ) {
        productInventoryList[productIndex].replenish = true
      } else {
        productInventoryList[productIndex].replenish = false
      }
    } else {
      productInventoryList[productIndex].replenish = payload.replenish
      productInventoryList[productIndex].variantId = payload.variantId
    }

    state.productInventoryList = productInventoryList
  },
  [UPDATE_PRODUCT_REPLENISH_QUANTITY](state, payload) {
    let productInventoryList = [...state.productInventoryList]

    if (payload.isVariant) {
      const productIndex = productInventoryList.findIndex(
        product => product.id == payload.id
      )

      const variantIndex = productInventoryList[
        productIndex
      ].sortedProductVaraints.findIndex(
        productVariant => productVariant.id === payload.variantId
      )

      productInventoryList[productIndex].sortedProductVaraints[
        variantIndex
      ].replenishQuantity = payload.quantity || ''

      productInventoryList[productIndex].sortedProductVaraints[
        variantIndex
      ].replenishQuantityError = payload.replenishQuantityError

      productInventoryList[productIndex].sortedProductVaraints[
        variantIndex
      ].replenish = payload.replenish
    } else {
      const productIndex = productInventoryList.findIndex(
        product => product.id == payload.id
      )
      productInventoryList[productIndex].replenishQuantity =
        payload.quantity || ''
    }

    state.productInventoryList = productInventoryList
  },
  [UPDATE_PRODUCT_REPLENISH_ERROR](state, payload) {
    let productInventoryList = [...state.productInventoryList]

    if (
      productInventoryList[payload.originalIndex].sortedProductVaraints &&
      productInventoryList[payload.originalIndex].sortedProductVaraints.length >
        1
    ) {
      productInventoryList[payload.originalIndex].sortedProductVaraints[
        payload.variantIndex
      ].replenishQuantityError = payload.error
      // productInventoryList[payload.originalIndex].replenishQuantityError =
      //   payload.error
    } else {
      productInventoryList[payload.originalIndex].replenishQuantityError =
        payload.error
    }
    state.productInventoryList = productInventoryList
  },
  [RESET_PRODUCTS_TO_REPLENISH](state) {
    let productInventoryList = [...state.productInventoryList]
    productInventoryList = productInventoryList.map(product => {
      return {
        ...product,
        replenish: false
      }
    })
    state.productInventoryList = productInventoryList
  },
  [REPLENISH_PRODUCTS](state, payload) {
    state.isReplenishProducts = payload
  },
  [TOGGLING_PRODUCT_VISIBILITY](state, payload) {
    state.togglinProductVisibility = payload
  },
  [SET_UPDATED_PRODUCT_INVENTORY](state, payload) {
    let storeInventoryList = [...state.storeInventoryList]
    storeInventoryList[payload.originalIndex].adminOnly = payload.adminOnly
    state.storeInventoryList = storeInventoryList
  },
  [RESET_INVENTORY_STATE](state) {
    Object.assign(state, getInventoryStoreDefaultState())
  },
  [UPDATING_PRODUCT](state, payload) {
    state.updatingProduct = payload
  },
  [INVENTORY_PAGINATION_COUNT](state, payload) {
    state.totalCount = payload
  },
  [STORE_INVENTORY_PAGINATION](state, payload) {
    state.storeTotalCount = payload
  }
}
